import React from 'react';

import { renderInternalLink } from '../../utils';

import {
  Container,
  ContentSection,
  OKSection,
  LinkElement,
  InfoElement,
  LinkSection,
  Dot,
} from './cookiePopup.styled';
import { CookiePopupData } from './cookiePopup.types';

export const CookiePopup: React.FC<CookiePopupData> = (data: CookiePopupData) => {
  const {
    content,
    isAlertVisible,
    privacyPolicy,
    currentLanguage,
    readMoreButtonLabel,
    closeAction = Function.prototype,
  } = data;

  const closeAlert = (): void => {
    closeAction();
  };

  return (
    <Container isVisible={isAlertVisible}>
      <ContentSection>
        <InfoElement>{content}</InfoElement>
        <LinkSection>
          <Dot />
          <LinkElement>
            {renderInternalLink(readMoreButtonLabel, privacyPolicy, currentLanguage)}
          </LinkElement>
          <Dot />
        </LinkSection>
      </ContentSection>
      <OKSection onClick={closeAlert}>
        OK
      </OKSection>
    </Container>
  );
}
